import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import noop from 'lodash/noop';
import includes from 'lodash/includes';

import '../../SearchApp/components/searchMap/interactiveMapMarker/InteractiveMapMarker';

export default class InteractiveMapMarker extends React.PureComponent {
    static propTypes = {
        onMapMarkerClick: PropTypes.func,
        eventsId: PropTypes.arrayOf(PropTypes.string),
        isMobileViewEventDefaultSelected: PropTypes.bool,
        mobileViewHoverTarget: PropTypes.string,
    };

    static defaultProps = {
        eventsId: [],
        onMapMarkerClick: noop,
    };

    _setRef = (node) => {
        this._ref = node;
    };

    _handleMapMarkerClickWithPosition = () => {
        this.props.onMapMarkerClick(this._ref);
    };

    render() {
        const {
            eventsId,
            hoverEventCardTarget,
            mobileViewHoverTarget,
        } = this.props;

        const shouldHover = !!eventsId.find((eventId) =>
            includes([hoverEventCardTarget, mobileViewHoverTarget], eventId),
        );
        const containerClassName = classNames(
            'interactive-map-marker__container',
            {
                'interactive-map-marker__container--hover': shouldHover,
            },
        );

        return (
            <div
                className={containerClassName}
                data-spec="interactive-map-marker-container"
            >
                <svg
                    width="34"
                    height="38"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="interactive-map-marker"
                    onClick={this._handleMapMarkerClickWithPosition}
                    onKeyDown={this._handleMapMarkerClickWithPosition}
                    role="button"
                    ref={this._setRef}
                >
                    <g filter="url(#filter0_d)">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M23.375 21.2153C24.9498 19.6006 25.92 17.3936 25.92 14.96C25.92 10.0115 21.9085 6 16.96 6C12.0115 6 8 10.0115 8 14.96C8 17.3795 8.95901 19.575 10.5176 21.1872L16.2233 27.5596C16.6213 28.004 17.3173 28.0034 17.7145 27.5584L23.375 21.2153Z"
                            fill="#FFD601"
                        />
                    </g>
                    <defs>
                        <filter
                            id="filter0_d"
                            x="0"
                            y="0"
                            width="33.92"
                            height="37.8925"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood
                                floodOpacity="0"
                                result="BackgroundImageFix"
                            />
                            <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            />
                            <feOffset dy="2" />
                            <feGaussianBlur stdDeviation="4" />
                            <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0.301961 0 0 0 0 0.180392 0 0 0 0 0.238745 0 0 0 0.2 0"
                            />
                            <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow"
                                result="shape"
                            />
                        </filter>
                    </defs>
                </svg>
            </div>
        );
    }
}
